import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'taxOptionsMapping'
})
export class TaxOptionsMappingPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    const options: { label: string, value: any, taxVal: any }[] = args[0];
    const option = options.find(x => x.value === value);
    return option?.label ?? value;
  }

}
